<template>
  <div class="infos">
    <div class="left">
      <div class="tx"><img :src="data.logoUrl" alt="" /></div>
      <div class="titles">
        <div class="name">{{ data.name }}</div>
        <div class="fans">{{ data.funsCount }}<span> 粉丝</span></div>
      </div>
    </div>
    <div v-if="source == 'index'" class="right">
      <div @click="toMiniwechat" class="btn">
        <div>
          <img
            src="https://img.zai-art.com/zaiart/saas/image/md/389494ec7d0b18972ea0d9fe506a18a1.png"
            alt=""
          />
        </div>
        进店
      </div>
      <div v-if="false" class="btn">
        <div>
          <img
            src="https://img.zai-art.com/zaiart/saas/image/md/d9c732c5f4c1d76f8792437c64e9ca07.png"
            alt=""
          />
        </div>
        分享
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['data', 'source'],
  name: '',
  data() {
    return {};
  },
  computed: {},
  methods: {
    toMiniwechat() {
      console.log(this.$store.state.app.shopId);
      let path = encodeURIComponent(`/pages/shop/index?id=${this.$store.state.app.shopId}`);
      wx.miniProgram.navigateTo({
        url: `/pages/openMini/index?path=${path}&appid=wx85f3340de9840fb8`,
      });
    },
  },
};
</script>
<style lang="less" scoped>
.infos {
  width: 93.6%;
  margin: 0 auto;
  height: 114px;
  background: #ffffff;
  box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.02);
  border-radius: 4px;
  z-index: 1;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
  .left {
    display: flex;
    flex: 1;
    .tx {
      width: 74px;
      height: 74px;
      display: block;
      border-radius: 50%;
      background: #f8f8f8;
      margin-right: 15px;
      img {
        width: 100%;
        height: 100%;
        display: block;
        border-radius: 50%;
        object-fit: cover;
      }
    }
    .titles {
      padding-top: 12px;
      max-width: 65%;
      .name {
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #222222;
        line-height: 25px;
        margin-bottom: 5px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
      .fans {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #222222;
        line-height: 20px;
        span {
          font-size: 13px;
          color: #999999;
        }
      }
    }
  }
  .right {
    display: flex;
    padding-top: 19px;
    .btn {
      font-size: 11px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 12px;
      margin-left: 20px;
      text-align: center;
      img {
        width: 18px;
        height: 18px;
        display: inline-block;
        margin-bottom: 5px;
        background: #f8f8f8;
      }
    }
  }
}
</style>
